import { CircleAlert, CircleCheck, Info } from "lucide-react";
var TOAST_TYPES = {
  success: {
    icon: CircleCheck
  },
  warning: {
    icon: CircleAlert
  },
  error: {
    icon: CircleAlert
  },
  info: {
    icon: Info
  },
  general: {
    icon: Info
  }
};
export default TOAST_TYPES;